// extracted by mini-css-extract-plugin
export var actions = "_51-0";
export var actionsContainer = "_51-6";
export var border = "_51-1";
export var childFullHeight = "_51-d";
export var collapse = "_51-2";
export var content = "_51-8";
export var contentChild = "_51-c";
export var fullscreen = "_51-a";
export var hasLeftRadius = "_51-h";
export var headerContainer = "_51-3";
export var headerRow = "_51-5";
export var hidePadding = "_51-9";
export var navCollapsedGap = "_51-i";
export var noScrollX = "_51-j";
export var noScrollY = "_51-k";
export var optOutTopPadding = "_51-b";
export var pageMain = "_51-g";
export var pageOuter = "_51-e";
export var pagePadding = "_51-7";
export var profile = "_51-l";
export var profileContainer = "_51-m";
export var profileImage = "_51-n";
export var profileMain = "_51-o";
export var profileSubtitle = "_51-q";
export var profileTitle = "_51-p";
export var showLeftPadding = "_51-f";
export var tabsWrapper = "_51-4";
export var title = "_51-r";